module.exports = __webpack_public_path__ + "img/caprock-logo.b2ef2469.png";